/*
 * Sportsact: "Andre købte også" i kurvskuffen (snippets/custom-cart-upsell.liquid).
 * Henter complementary, derefter related, via sections/custom-cart-recommendations.liquid.
 * Kurvskuffen gen-renderes af Impact ved hver kurvændring, så elementet hentes på ny hver gang.
 */
(() => {
  // Scriptet kan indlæses flere gange (kurvskuffen gen-renderer sektioner), så kør kun første gang
  if (window.customElements.get('custom-cart-upsell')) return;

  class CustomCartUpsell extends HTMLElement {
    async connectedCallback() {
      const productId = this.getAttribute('product-id');

      for (const intent of ['complementary', 'related']) {
        try {
          const url = `${window.Shopify.routes.root}recommendations/products?product_id=${productId}&limit=10&intent=${intent}&section_id=custom-cart-recommendations`;
          const html = await (await fetch(url)).text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const limit = parseInt(this.getAttribute('limit'), 10) || 3;
          const cards = [...doc.querySelectorAll('.custom-upsell-card')].slice(0, limit);

          if (cards.length) {
            this.querySelector('.custom-cart-upsell__list').replaceChildren(...cards.map((card) => document.importNode(card, true)));
            this.hidden = false;
            return;
          }
        } catch (error) {
          return;
        }
      }
    }
  }

  window.customElements.define('custom-cart-upsell', CustomCartUpsell);
})();
